module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AgentUpgradeView.js"));
	}, "AgentUpgradeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentUpgradeView!./src/pages/Store/BusinessManage/AgentUpgrade/AgentUpgradeView.js
// module id = 1206
// module chunks = 431